<nz-modal [(nzVisible)]="visible" nzTitle="Record did not matched." (nzOnCancel)="visible = false" (nzOnOk)="handleOk()"
  nzOkText="Yes" nzCancelText="No">
  <ng-container *nzModalContent>
    <div>
      Do you want to replace existing TIN, Address, and Zip Code?
    </div>
    <br />
    <app-bir-info-view [data]="data"></app-bir-info-view>
  </ng-container>
</nz-modal>
